import {
  Lightbulb,
  UserPlus,
  Home,
  Grid2x2
} from 'lucide-react'

import { useCurrentUser } from '@contexts/currentUser'
import { useQuery } from '@hooks/graphql'
import TechnicalDifficultiesBanner from './TechnicalDifficultiesBanner'
import MembershipPicker from './MembershipPicker'
import OnboardingChecklist from '../students/components/OnboardingChecklist'
import Navbar from './Navbar/Navbar'

const CLASSROOMS_QUERY = `
  query enrolledClassrooms($archived: Boolean!) {
    enrolledClassrooms(archived: $archived) {
      id
      name
    }
  }
`

const StudentNav = () => {
  const { currentMembership } = useCurrentUser()
  const features = currentMembership?.organization?.features || []

  const { data: { enrolledClassrooms = [] } = {} } = useQuery({
    queryKey: ['menu_enrolled_classrooms', false],
    gqlQuery: CLASSROOMS_QUERY,
    variables: { archived: false },
    onSuccess: (data) => {
    },
    onError: (error) => {
      console.error(error)
    }
  })

  const navigation = [
    { name: 'Home', href: '/students', icon: Home, exact: true },
  ]

  if (features.includes('tutor_insights')) {
    navigation.push({ name: 'Insights', href: '/students/tutor_insights', icon: Lightbulb })
  }

  navigation.push({ 
    name: 'Join Classroom', 
    href: '/students/join_short_code', 
    icon: UserPlus 
  })

  
  navigation.push({
    name: 'Classrooms',
    href: '/students/classrooms',
    items: [
      {
        name: 'All Classrooms',
        href: '/students/classrooms',
        icon: Grid2x2,
        exact: true
      },
      ...enrolledClassrooms.slice(0, 8).map(classroom => ({
        name: classroom.name || "",
        href: `/students/classrooms/${classroom.id || ""}`,
    }))],
  })

  const technicalDifficultiesBannerEnabled = features.includes('technical_difficulties_banner')
  const footerItems = []

  if (features.includes('student_events')) {
    footerItems.push({ name: 'Workshops', href: '/students/workshops', icon: Grid2x2 })
  }

  return (
    <Navbar showTrails={true}>
      <Navbar.Header>
        <Navbar.Logo />
      </Navbar.Header>

      <Navbar.Content>
        <Navbar.List items={navigation} />
      </Navbar.Content>

      <Navbar.Footer>
        <If condition={technicalDifficultiesBannerEnabled}>
          <TechnicalDifficultiesBanner />
        </If>
        <OnboardingChecklist />
        <Navbar.List items={footerItems} />
        <div className="p-2">
          <MembershipPicker />
        </div>
      </Navbar.Footer>
    </Navbar>
  )
}

export default StudentNav
